module.exports = __webpack_public_path__ + "img/福岡市中央区春吉3丁目21－21 春野ビル5階E (5F E, Haruno Building, 3-21-21 Haruyo.5d7984fe.png";